import React, { useContext }  from 'react'
import {localestr,dataContext} from '../utils'


function WndForm({Text,caption,idx,action,typeVal,stl_,resizeable=true}){
  const context=useContext(dataContext)
  const setSettings=context.setSettings
  const getSettings=context.getSettings
  const usersettings=getSettings()

    let posX = 0, posY = 0

    function dragMouseDown(e) {
      e = e || window.event;
      posX = e.clientX;
      posY = e.clientY;
      document.onmouseup = closeDragElement;
      document.onmousemove = elementDrag;
    }

    function elementDrag(e) {
        let pos1 = 0, pos2 = 0
        const elmnt=document.getElementById('wnd'+idx)
        e = e || window.event;
        // calculate the new cursor position:
        pos1 = posX - e.clientX;
        pos2 = posY - e.clientY;
        posX = e.clientX;
        posY = e.clientY;
        // set the element's new position:
        let new_top=elmnt.offsetTop - pos2
        if(new_top<0) new_top=0
        if(new_top>window.innerHeight-30) new_top=window.innerHeight-30
        if (pos2!==0) elmnt.style.top = new_top + "px";
        if (pos1!==0) elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
        let setting={}
        setting[typeVal]={left:elmnt.style.left,top:elmnt.style.top,width:elmnt.style.width,height:elmnt.style.height}
        setSettings(setting)
      }
    
      function closeDragElement() {
        /* stop moving when mouse button is released:*/
        document.onmouseup = null;
        document.onmousemove = null;
        document.ontouchend = null;
        document.ontouchcancel = null;
        document.ontouchmove = null;
      }

      function resizeMouseDown(e,x=1,y=1) {
        e = e || window.event;
        // get the mouse cursor position at startup:
        posX = e.clientX;
        posY = e.clientY;
        document.onmouseup = closeDragElement;
        // call a function whenever the cursor moves:
        document.onmousemove = (e)=>elementResize(e,x,y)
      }

      function elementResize(e,x,y) {
        let pos1 = 0, pos2 = 0
        const elmnt=document.getElementById('wnd'+idx)
        e = e || window.event;
        // calculate the new cursor position:
        pos1 = posX - e.clientX;
        pos2 = posY - e.clientY;
        posX = e.clientX;
        posY = e.clientY;
        let new_top=elmnt.offsetTop - pos2
        if(new_top<0) new_top=0
        // set the element's new position:
        if (pos1!==0) elmnt.style.width = (elmnt.offsetWidth - pos1*x) + "px";
        if (pos2!==0) elmnt.style.height = (elmnt.offsetHeight - pos2*y) + "px";
        if (pos1!==0&&x===-1) elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
        if (pos2!==0&&y===-1) elmnt.style.top = new_top + "px";
        let setting={}
        setting[typeVal]={left:elmnt.style.left,top:elmnt.style.top,width:elmnt.style.width,height:elmnt.style.height}
        setSettings(setting)
      }

      function dragTouchDown(e) {
        e = e || window.event;
        posX = parseInt(e.changedTouches[0].clientX)
        posY = parseInt(e.changedTouches[0].clientY)
        document.ontouchend = closeDragElement;
        document.ontouchcancel = closeDragElement;
        document.ontouchmove = touchDrag;
      }

      function touchDrag(e) {
        let pos1 = 0, pos2 = 0
        const elmnt=document.getElementById('wnd'+idx)
        e = e || window.event;
        // calculate the new cursor position:
        pos1 = posX - parseInt(e.changedTouches[0].clientX)
        pos2 = posY - parseInt(e.changedTouches[0].clientY)
        posX = parseInt(e.changedTouches[0].clientX)
        posY = parseInt(e.changedTouches[0].clientY)
        let new_top=elmnt.offsetTop - pos2
        if(new_top<0) new_top=0
        // set the element's new position:
        if (pos2!==0) elmnt.style.top = new_top + "px";
        if (pos1!==0) elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
        let setting={}
        setting[typeVal]={left:elmnt.style.left,top:elmnt.style.top,width:elmnt.style.width,height:elmnt.style.height}
        setSettings(setting)
      }

      function resizeTouchDown(e,x=1,y=1) {
        e = e || window.event;
        // get the mouse cursor position at startup:
        posX = parseInt(e.changedTouches[0].clientX)
        posY = parseInt(e.changedTouches[0].clientY)
        document.ontouchend = closeDragElement;
        document.ontouchcancel = closeDragElement;
        document.ontouchmove = (e)=>touchResize(e,x,y);
        //document.onmousemove = (e)=>elementResize(e,x,y)
      }

      function touchResize(e,x,y) {
        let pos1 = 0, pos2 = 0
        const elmnt=document.getElementById('wnd'+idx)
        e = e || window.event;
        // calculate the new cursor position:
        pos1 = posX - parseInt(e.changedTouches[0].clientX)
        pos2 = posY - parseInt(e.changedTouches[0].clientY)
        posX = parseInt(e.changedTouches[0].clientX)
        posY = parseInt(e.changedTouches[0].clientY)
        let new_top=elmnt.offsetTop - pos2
        if(new_top<0) new_top=0
        // set the element's new position:
        if (pos1!==0) elmnt.style.width = (elmnt.offsetWidth - pos1*x) + "px";
        if (pos2!==0) elmnt.style.height = (elmnt.offsetHeight - pos2*y) + "px";
        if (pos1!==0&&x===-1) elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
        if (pos2!==0&&y===-1) elmnt.style.top = new_top + "px";
        let setting={}
        setting[typeVal]={left:elmnt.style.left,top:elmnt.style.top,width:elmnt.style.width,height:elmnt.style.height}
        setSettings(setting)
      }

      let stl={width:'80%',height:'80%',minWidth:'250px',maxWidth:'98%'}
      //if(typeVal==='catGoods_edit') stl={width:'370px',height:'250px'}
      //else if(typeVal.slice(-5)==='_edit') stl={width:'370px',height:'80%',minWidth:'250px'}

      if (usersettings){
        if (usersettings[typeVal]){
          if (usersettings[typeVal].left) stl.left=usersettings[typeVal].left
          if (usersettings[typeVal].top) stl.top=usersettings[typeVal].top
          if (usersettings[typeVal].width) stl.width=usersettings[typeVal].width
          if (usersettings[typeVal].height) stl.height=usersettings[typeVal].height
          if(parseInt(stl.left)+parseInt(stl.width)>window.innerWidth) stl.left='5px'
        }
      }

      if(stl_) stl={...stl,...stl_}
      
      if(resizeable){
        return(
          <div id={'wnd'+idx} className='window' style={stl}>
              <div onMouseDown={dragMouseDown} onTouchStart={dragTouchDown} style={{flexDirection:'row',display:'flex',justifyContent:'flex-start'}}><div className='caption no-print'>{caption||localestr('Повідомлення')}</div><div className='closebtn' onClick={action}/></div>
              <div className='content'>
              <div style={{margin:'0 0 0 0',display:'flex',justifyContent:'center',whiteSpace:'pre-wrap',height:'100%'}}>
                  {Text}
              </div>
              </div>
              <div onMouseDown={(e)=>resizeMouseDown(e,1,1)} onTouchStart={(e)=>resizeTouchDown(e,1,1)} style={{width:'10px',height:'10px',position:'absolute',right:'0',bottom:'0',cursor:'se-resize'}}></div>
              <div onMouseDown={(e)=>resizeMouseDown(e,-1,1)} onTouchStart={(e)=>resizeTouchDown(e,-1,1)} style={{width:'10px',height:'10px',position:'absolute',left:'0',bottom:'0',cursor:'sw-resize'}}></div>
              <div onMouseDown={(e)=>resizeMouseDown(e,1,-1)} onTouchStart={(e)=>resizeTouchDown(e,1,-1)} style={{width:'10px',height:'10px',position:'absolute',right:'0',top:'0',cursor:'ne-resize'}}></div>
              <div onMouseDown={(e)=>resizeMouseDown(e,-1,-1)} onTouchStart={(e)=>resizeTouchDown(e,-1,-1)} style={{width:'10px',height:'10px',position:'absolute',left:'0',top:'0',cursor:'nw-resize'}}></div>
          </div>
        )
      } else {
        return(
          <div id={'wnd'+idx} className='window' style={stl}>
              <div onMouseDown={dragMouseDown} onTouchStart={dragTouchDown} style={{flexDirection:'row',display:'flex',justifyContent:'flex-start'}}><div className='caption no-print'>{caption||localestr('Повідомлення')}</div><div className='closebtn' onClick={action}/></div>
              <div className='content'>
              <div style={{margin:'0 0 0 0',display:'flex',justifyContent:'center',whiteSpace:'pre-wrap',height:'100%'}}>
                  {Text}
              </div>
              </div>
          </div>
        )
      }
}

export default WndForm